import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { APIErrorResponse, ResearcherEventAttentionTask } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { QUERY_KEYS } from '@/constants'

export type UseGetAttentionTasksProps = {
  id: number
  isEnabled?: boolean
}

export const useGetAttentionTasks = ({
  id,
  isEnabled = true,
}: UseGetAttentionTasksProps): UseQueryResult<
  ResearcherEventAttentionTask[],
  APIErrorResponse
> => {
  const client = useApiClient()

  return useQuery(
    [QUERY_KEYS.ATTENTION_TASKS, id],
    () =>
      client
        .get(`plannings/events/manager/${id}/attention_tasks/`)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      enabled: isEnabled && !!id,
      refetchOnWindowFocus: false,
    }
  )
}
